import _ from 'lodash';
import { mapState } from 'vuex';
import store from '@/store/store';

export default {
  data: () => ({
    applications: [],
    loading: true,
    inactiveStatus: false,
    search: '',
    options: {
      itemsPerPage: -1
    }
  }),
  async mounted() {
    await store.dispatch('applications/getApplications', this.user.commonid);
    this.applications = this.loadActiveApplications();
    this.loading = false;
  },
  computed: {
    ...mapState('auth', ['user']),
    selected: function() {
      return this.$route.params.id;
    }
  },
  methods: {
    makingTheApplicationList(activeAppList) {
      let uniqueApps = _.uniqBy(activeAppList, 'id');
      let orderedApps = _.orderBy(uniqueApps, [(app) => app.name], ['asc']);
      let groupedApplications = _.groupBy(orderedApps, function(item) {
        return item.friendlyName;
      });
      let orderedGroupedApps = _.orderBy(groupedApplications, [(group) => group[0].friendlyName], ['asc']);
      return orderedGroupedApps;
    },
    loadActiveApplications() {
      let rawList = this.$store.state.applications.items;
      let activeApps = _.filter(rawList, function(a) {
        return a.appHubStatus !== false;
      });
      let activeAppList = this.makingTheApplicationList(activeApps);
      return activeAppList;
    },
    loadAllApplications() {
      let allApps = this.$store.state.applications.items;
      let allAppList = this.makingTheApplicationList(allApps);
      return allAppList;
    },
    changeState(item) {
      if (item) {
        this.applications = this.loadAllApplications();
      } else {
        this.applications = this.loadActiveApplications();
      }
    }
  }
};
